export const NAVY = "#142344";
export const PINK = "#D81B60";
export const YELLOW = "#FFC83D";
export const CREAM = "#FFF7E8";

export const DIYA = {
  bowl: "M20 120 Q120 112 220 120 Q212 182 120 190 Q28 182 20 120 Z",
  rim: "M12 114 Q120 98 228 114 Q230 128 216 130 Q120 116 24 130 Q10 128 12 114 Z",
  base: "M88 188 L152 188 L164 210 L76 210 Z",
  flameOuter: "M120 14 C142 46 154 70 144 92 C137 106 103 106 96 92 C86 70 98 46 120 14 Z",
  flameInner: "M120 48 C131 65 135 78 130 89 C126 96 114 96 110 89 C105 78 109 65 120 48 Z",
  zig: "M38 140 l12 9 l12 -9 l12 9 l12 -9 l12 9 l12 -9 l12 9 l12 -9 l12 9 l12 -9 l12 9 l12 -9 l12 9 l10 -7",
};
export const DIYA_DOTS = [52, 76, 100, 120, 140, 164, 188];

export function sunburstPolys(n = 22, r = 100) {
  const out = [];
  for (let i = 0; i < n; i++) {
    const a0 = (i / n) * Math.PI * 2;
    const a1 = a0 + (Math.PI / n) * 0.9;
    out.push(`0,0 ${(Math.cos(a0) * r).toFixed(1)},${(Math.sin(a0) * r).toFixed(1)} ${(Math.cos(a1) * r).toFixed(1)},${(Math.sin(a1) * r).toFixed(1)}`);
  }
  return out;
}

export const SPARKLE = "M0 -14 C2 -4 4 -2 14 0 C4 2 2 4 0 14 C-2 4 -4 2 -14 0 C-4 -2 -2 -4 0 -14 Z";

export function marigoldPetals(r = 14) {
  return Array.from({ length: 10 }, (_, i) => {
    const a = (i / 10) * Math.PI * 2;
    return { x: Math.cos(a) * r * 0.62, y: Math.sin(a) * r * 0.62, r: r * 0.45 };
  });
}
